<template>
  <div>
    <ly-group>
      <ly-item
        :class="{ red: x.search }"
        v-for="(x, index) in dataList"
        :key="index"
        ><Icon class="beforeicon" :type="ttt[x.useType]"></Icon>{{ x.name
        }}<Icon @click="dataList.splice(index, 1)" type="ios-backspace-outline"
      /></ly-item>
    </ly-group>
    <div class="clearfloat" style="widthL100%">
      <div style="float: left">
        <Button @click="add" type="success">新增</Button>
        <Button @click="dataList.splice(0, dataList.length)">清空</Button>
      </div>
      <div style="float: left;margin-left:20px">
        <ly-search v-model="keyword" @search="search"></ly-search>
      </div>
      <div style="float: right">
        <Button type="primary" @click="save">提交保存</Button>
      </div>
    </div>
    <Drawer
      title="请选择设备"
      placement="right"
      :closable="true"
      v-model="openForm"
      draggable
      class="my-drawer"
      width="450"
    >
      <device-tool ref="deviceTool" v-if="openForm" @car="reCars">
        <Button @click="$refs.deviceTool.addAll()" slot="btn" long
          >全部添加</Button
        >
      </device-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["dataList123"],
  data() {
    return {
      openForm: false,
      dataList: [],
      ttt: {
        0: "md-pin",
        1: "md-car",
        2: "md-person",
        3: "md-pin",
      },
      keyword: "",
    };
  },
  methods: {
    add() {
      this.openForm = true;
    },

    reCars(v) {
      var obj = {
        name: v.bind,
        id: v.id,
        useType: v.useType,
      };

      var result = this.dataList.some((item) => {
        if (item.id == obj.id) {
          return true;
        }
      });
      if (result) {
        this.$Message.error("（" + obj.name + "）已存在");
      } else {
        this.dataList.unshift(obj);
      }
    },
    save() {
      this.$emit("bind", this.dataList);
    },
    search() {
      var d = this.dataList;
      for (let i = 0; i < d.length; i++) {
        //this.dataList[i].search = false;
        this.$set(this.dataList[i], "search", false);
        if (d[i].name.indexOf(this.keyword) != -1 && this.keyword.length > 0) {
          this.dataList[i].search = true;
        }
      }
    },
  },
  model: {
    prop: "dataList123",
    event: "aaa",
  },
  watch: {
    dataList123(v) {
      this.dataList = v;
    },
  },
};
</script>
<style>
#lygroup .red {
  background: #d93838;
  color: aliceblue;
}
</style>


// WEBPACK FOOTER //
// src/components/common/bindTool.vue